import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {APIConfig} from '../app.constant';
import {Observable} from 'rxjs/Observable';
import {QuestionResponse} from '../models/response.model';
import {HttpHeaders} from '@angular/common/http';
import {SessionService} from './session.service';

@Injectable()
export class ResponseService extends BaseService {

  getResponses(client: string, project: string): Observable<QuestionResponse[]> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.get<QuestionResponse[]>(APIConfig.API_RESPONSE_URL + '?client=' + client + '&project=' + project, this.options);
  }

  saveResponses(data: QuestionResponse[]): Observable<QuestionResponse[]> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.post(APIConfig.API_RESPONSE_URL, {'array': data}, this.options);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/services/response.service.ts